<template>
  <div class="RP-Home">
    <ul class="RP-MenuList">
      <li class="MenuMaginLeft" v-for="(item, index) in MenuList" v-bind:key="index" :class="[
        index % 6 == 0
          ? 'MenuYellow'
          : index % 6 == 1
            ? 'MenuBlue'
            : index % 6 == 2
              ? 'MenuRed'
              : index % 6 == 3
                ? 'MenuPurple'
                : index % 6 == 4
                  ? 'MenuTurquoise'
                  : 'MenuGreen',
      ]" @click="goToMenu(item)">
        <i v-bind:class="item.Icon"></i>
        <div class="MenuName">
          {{ item.MenuName }}
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      MenuList: [],
      RoleID:sessionStorage.getItem('RoleID'),
    };
  },
  created() {
    this.$Http_Post('User/GetRoleMenu',{RoleID:this.RoleID}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.MenuList = res.Data;
      }else if(res.Code==208){
        this.$router.push('/login');
      }
    });
  },
  methods: {
    goToMenu: function (obj) {
      if (obj.LinkURL == null || obj.LinkURL == '') {
        this.$router.push({
          path: '/ReportData/RPIndexOther',
          query: { MyPMenuID: obj.MenuID, Control: obj.Control },
        });
      } else {
        this.$router.push({
          path: obj.LinkURL,
          query: { Control: obj.Control },
        });
      }
    },
  },
};
</script>
<style>
.RP-Home {
  width: 100%;
  height: 100%;
  background-image: url('../../assets/img/ReportData/RPMain-BG.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
}

.RP-MenuList {
  position: absolute;
  width: 80%;
  height: 60%;
  padding: 14px 0;
  overflow: hidden;
  margin-left: 10%;
  margin-top: 10%;
}

.RP-MenuList li {
  float: left;
  width: 21%;
  height: 25%;
  color: white;
  position: relative;
  cursor: pointer;
  box-shadow: 0px 0px 10px gray;
  background-image: url('../../assets/img/ReportData/menu-bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: 16px;
}

.RP-MenuList li:hover {
  box-shadow: 0px 0px 15px rgb(248, 248, 250);
}

.MenuMaginLeft {
  margin-left: 5%;
}

.MenuYellow {
  background: linear-gradient(90deg,
      rgba(252, 236, 112, 1) 0%,
      rgba(250, 220, 10, 1) 100%);
}

.MenuBlue {
  background: linear-gradient(90deg,
      rgba(170, 220, 255, 1) 0%,
      rgba(23, 152, 246, 1) 100%);
}

.MenuRed {
  background: linear-gradient(90deg,
      rgba(248, 185, 154, 1) 0%,
      rgba(247, 96, 96, 1) 100%);
}

.MenuPurple {
  background: linear-gradient(90deg,
      rgba(199, 159, 245, 1) 0%,
      rgba(123, 107, 246, 1) 100%);
}

.MenuTurquoise {
  background: linear-gradient(90deg,
      rgba(145, 251, 234, 1) 0%,
      rgba(60, 208, 193, 1) 100%);
}

.MenuGreen {
  background: linear-gradient(90deg,
      rgba(183, 250, 145, 1) 0%,
      rgba(68, 209, 61, 1) 100%);
}

.MenuName {
  width: 100%;
  text-align: center;
  margin: auto;
  position: absolute;
  left: 0;
  bottom: 15%;
  right: 0;
}

.iconfont {
  position: absolute;
  top: 15%;
  left: 0;
  right: 0;
}

@media screen and (min-height: 850px) {
  .RP-MenuList li {
    font-size: 20px;
  }

  .iconfont {
    font-size: 50px;
  }
}

@media screen and (min-height: 750px) and (max-height: 849px) {
  .RP-MenuList li {
    font-size: 18px;
  }

  .iconfont {
    font-size: 40px;
  }
}

@media screen and (min-height: 650px) and (max-height: 749px) {
  .RP-MenuList li {
    font-size: 16px;
  }

  .iconfont {
    font-size: 30px;
  }
}

@media screen and (max-height: 649px) {
  .RP-MenuList li {
    font-size: 14px;
  }

  .iconfont {
    font-size: 20px;
  }
}
</style>
